import type { SchemaFailureHandler } from "@reduxjs/toolkit/query";
import type { z } from "zod";

import { logger } from "common/utilities/logger";
import { unsafelyEntries } from "common/utilities/object";

export const handleSchemaFailure: SchemaFailureHandler = (error, info) => {
  const errorMessage = `Schema validation error at endpoint: ${info.endpoint}\n${JSON.stringify(error.issues)}`;
  logger.error(errorMessage);
};

export const toSearchString = (params: Record<string, string | number | boolean | undefined>) => {
  const searchParams = new URLSearchParams();
  unsafelyEntries(params).forEach(([key, value]) => {
    if (value !== undefined) searchParams.set(key, value.toString());
  });
  const searchParamsString = searchParams.toString();
  return searchParamsString.length <= 0 ? searchParamsString : `?${searchParamsString}`;
};

export const nullToUndefined = <T extends z.ZodType>(schema: T): z.ZodEffects<z.ZodOptional<z.ZodNullable<T>>> =>
  schema.nullish().transform((value: T | null | undefined) => value ?? undefined);
